import { NoteModel } from '../../models/student-notes/note.model';
import { NoteService } from './pegasus-epona/note.service';

export class NotesReaderService {
  public static async getNoteOriginUrl(note: NoteModel): Promise<string> {
    return NoteService.getUpdatedNoteOriginUrlByNote(note);
  }
}
